import { Stack, Title, Button } from '@mantine/core';
import { IconMailOff } from '@tabler/icons-react';
import { primaryColor } from '../../../../constants/theme';
import { useNavigate } from 'react-router-dom';

export const NoEmailRender = () => {
  const navigate = useNavigate();

  return (
    <Stack align="center" justify="center" py={100} gap={10}>
      <IconMailOff size={60} color={primaryColor} />
      <Title order={4} fw="normal" c="dimmed" ta="center">
        You need to add an email to your profile to book appointments.
      </Title>
      <Button
        variant="outline"
        color={primaryColor}
        onClick={() => navigate('/edit-profile')}
      >
        Add Email
      </Button>
    </Stack>
  );
};
